import React, {Fragment} from 'react';
import PropTypes from 'prop-types';
import Link from 'react-router-dom/Link';
import { Icon, Button } from 'antd';
import './ContactSection.css';
import QuoteBlock from '../../common/QuoteBlock/QuoteBlock';
// import imgContact from '../../images/500/honeycomb-3143432_1920.jpg';

const ContactSection = (props) => {
  let bgClass;
  props.background==='none' ? bgClass = '' : bgClass = ' ContactSection--container-background';
  let containerClass = 'ContactSection--container' + bgClass;

   return (
      <Fragment>
      <div className={containerClass}>
        
        <div className="ContactSection--container-inner img-rounded">
          <div className="ContactSection--headline">
            <h2> 
              <Icon type="message" style={{marginRight:15}}/> Contact Us - We're Seeking Partners
            </h2>

            <QuoteBlock quote="1" />

            <div className="ContactSection--button-moreinfo">
              <Link to="/contact/">
                <Button size="large" type="primary"><Icon type="message" style={{marginRight:5}}/>Contact Us<Icon type="caret-right" /></Button>
              </Link>
            </div>

          </div>
        </div>
      </div>
      </Fragment>
    )
 }

 ContactSection.propTypes = {
    background: PropTypes.string
  };

 export default ContactSection;


// WEBPACK FOOTER //
// ./src/containers/ContactSection/ContactSection.js